<template>
  <header class="c-header" v-if="device != 2">
    <div class="c-header__inner">
      <my-scroll class="c-header__logo-link">
        <h1 class="c-header__logo"><span class="u-hide">UK Power Networks – Delivering your energy</span></h1>
      </my-scroll>
      <div class="c-header__tools">
        <a href="#download" @click.prevent="openDownload" class="c-header__tool c-header__tool--download">
          <svg class="icon icon-download"><use xlink:href="#icon-download"></use></svg>
        </a>
        <button @click="toggleMenu">
          <span class="c-header__tool c-header__tool--menu">
            <svg class="icon icon-bars" key="menu" v-if="!menuOpen"><use xlink:href="#icon-bars"></use></svg>
            <svg class="icon icon-cross" key="cross" v-else><use xlink:href="#icon-cross"></use></svg>
          </span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
// import MyHeadroom from '@/components/standard/my-headroom'
import MyScroll from '@/components/standard/my-scroll'

export default {
  name: 'my-header',
  components: {
    MyScroll
  },
  computed: {
    device () {
      return this.$store.state.device
    },
    menuOpen () {
      return this.$store.state.menuOpen
    }
  },
  methods: {
    toggleMenu () {
      this.$store.commit('toggleMenu')
    },
    openDownload () {
      this.$store.commit('setDownload', true)
      // this.$store.commit('setMenu', false)
    }
  }
}
</script>




// WEBPACK FOOTER //
// MyHeader.vue?0b977a12